export const setUserRole = [
    {
        label: "Administrator",
        value: "admin",
    },
    {
        label: "User",
        value: "user",
    },
];
